import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var VesselService = /** @class */ (function () {
    function VesselService(http) {
        this.http = http;
    }
    VesselService.prototype.getVessel = function (q, licNum) {
        var params = {
            q: q,
            licNum: licNum
        };
        return this.http.get('vessels/', { params: params });
    };
    VesselService.ngInjectableDef = i0.defineInjectable({ factory: function VesselService_Factory() { return new VesselService(i0.inject(i1.HttpClient)); }, token: VesselService, providedIn: "root" });
    return VesselService;
}());
export { VesselService };
